import { ProfileResource } from '@medplum/core';
import { Resource } from '@medplum/fhirtypes';
import { ResourceAvatar } from '@medplum/react';
import { CSSProperties, ReactElement } from 'react';
import { formatGivenFamilyName } from '@bariendo/lib/human-name';
import { isServiceAccount } from '@bariendo/lib/profile';
import { ActorAvatar } from './ActorAvatar';
import { automatedSenderLabel } from './SmsThreadAvatar';

/**
 * The avatar on a message bubble: the sender's photo or initials, unless the
 * sender is a service account, which takes the system marker (BAR-2864). The
 * thread header already makes that split; a reminder bubble inside the card
 * must not undo it by drawing the bot as a teammate.
 */
export function MessageSenderAvatar({
  sender,
  style,
}: {
  sender: Partial<ProfileResource> | Resource | undefined;
  style?: CSSProperties;
}): ReactElement {
  if (sender?.resourceType === 'Practitioner' && isServiceAccount(sender)) {
    return (
      <div style={style}>
        <ActorAvatar variant="system" label={automatedSenderLabel(formatGivenFamilyName(sender.name?.[0]))} />
      </div>
    );
  }

  return <ResourceAvatar value={sender as Resource} size="sm" style={style} />;
}
